// extracted by mini-css-extract-plugin
export default {"User":"user_User__gzBVn"};